module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Thanks to the following:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AREHAM")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMMER OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELEBRATION")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMITTEE")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Coordinator: Claire Smith")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("President: Rudy Santos")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Vice-president: Nancy Miller")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Clerk: Angela Dunham")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Treasurer: Robert Powilatis")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Board of directors: Sharon Boyer, Jovina Dean, Eleanor Martin, Malcolm Phinney, W. Robert White")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Committee members: Nora Bicki, Robert Blair, Linda Burke, Mary Jane Burke, Jacqui Healey, William Heaney, Mel Lazarus, Laura Lopes, Deborah McGonnell, John McGonnell, Clifford Sylvia, Paula Tufts")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBRARY")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OARD OF")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUSTEES")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Chair: Bethany Gay")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Vice-chair: Roger Bacchieri")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Secretary: William White")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Members: Johnna Fredrickson, Rachel Kuklinski, M. Kathleen LaFlamme Diane O’Brien")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Liaison to the board: Judy Whiteside")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AREHAM")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORICAL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMISSION")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Chair: Angela M. Dunham")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Vice-chair: Mack Phinney")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Treasurer: Len Boutin")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Clerk: Cheryl Knapp")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Board of selectmen liaison: Alan Slavin")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AREHAM")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORICAL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCIETY")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FFICERS")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("President: Angela M. Dunham")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Vice-president: Mary Hull")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Treasurer: Sandy Slavin")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Secretary: Cathy Phinney")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AREHAM")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORICAL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCIETY")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OARD")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMBERS")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("June Strunk")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Joella Cruz")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bernard Greenwood")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Paul Girard")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Alan Slavin")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("David Warr")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHORS")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Scott Ridley")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Michael Tougias")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Will Staples")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jennifer Reeser")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBLISHING")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tris Coburn, literary agent")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dani McGrath, Northeast sales, The History Press")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tabitha Dulla, commissioning editor, The History Press")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Darcy Mahan, project editor, The History Press")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5abd810","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgement.vue
// module id = 69
// module chunks = 0